import { PriceSection } from '~/shared/components/Summary/components/PriceSection';
import { SummaryList } from '~/shared/components/Summary/components/SummaryList';
import { SummaryDesktop } from '~/shared/components/Summary/components/SummaryDesktop';
import { useTranslation } from '~/shared/utils/translation';
import useProducts from '~/features/commerce-api/hooks/useProducts';
import { useLocalBasketState } from '~/features/basket/hooks/useLocalBasketState';

type ComponentProps = {
    onSubmit: () => void;
    disabledButton?: boolean;
    ctaLabel: string;
};
export const Summery = ({ ctaLabel, onSubmit, disabledButton }: ComponentProps) => {
    const { translate } = useTranslation();
    const { products } = useProducts();

    const { membership, setMembership } = useLocalBasketState();

    return (
        <SummaryDesktop>
            <SummaryList
                large={false}
                title={translate('basket.priceSectionTitle')}
                products={products}
            />
            <PriceSection
                ctaLabel={ctaLabel}
                membership={membership}
                setMembership={setMembership}
                signupLabel={
                    (translate('checkout.priceSection.signupLabel.part1'),
                    translate('checkout.priceSection.signupLabel.part2'),
                    translate('checkout.priceSection.signupLabel.part3'))
                }
                onCtaHandler={onSubmit}
                disabledButton={disabledButton}
            />
        </SummaryDesktop>
    );
};
